import { render } from "./SiteCommentModeration.vue?vue&type=template&id=5b3072b0&scoped=true"
import script from "./SiteCommentModeration.vue?vue&type=script&lang=js"
export * from "./SiteCommentModeration.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=5b3072b0&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3072b0"]])

export default __exports__